import { Button, Grid, IconButton } from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import { FieldArray } from "formik";
import React from "react";
import InputField from "src/components/ui-components/InputField";
import DeleteIcon from "@material-ui/icons/Delete";

const FormEncoded = ({ formRef, isLoading }) => {
  return (
    <>
      <Grid spacing={2} container>
        <FieldArray name="webMethodsRequestParams">
          {({ insert, remove, push }) => (
            <>
              {formRef.current.values.webMethodsRequestParams?.map(
                (field, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                      <InputField
                        label="Parameter Key *"
                        name={`webMethodsRequestParams.${index}.parameterKey`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
                      <InputField
                        label="Parameter Value"
                        name={`webMethodsRequestParams.${index}.parameterValue`}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sm={2}
                      md={2}
                      lg={2}
                      xl={2}
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      {formRef.current.values.webMethodsRequestParams.length >
                        1 && (
                        <IconButton
                          sx={{ p: "10px" }}
                          onClick={() => remove(index)}
                        >
                          <DeleteIcon fontSize="medium" />
                        </IconButton>
                      )}
                      {index ===
                        formRef.current.values.webMethodsRequestParams.length -
                          1 && (
                        <Button
                          sx={{
                            background:
                              "linear-gradient(to bottom, #072f40, #072f40)",
                            minWidth: 100,
                          }}
                          type="button"
                          variant="contained"
                          startIcon={<AddCircle />}
                          onClick={() => {
                            push({ parameterKey: "", parameterValue: "" });
                          }}
                          disabled={!field.parameterKey || isLoading}
                        >
                          Add
                        </Button>
                      )}
                    </Grid>
                  </React.Fragment>
                )
              )}
            </>
          )}
        </FieldArray>
      </Grid>
    </>
  );
};

export default FormEncoded;
